import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-common/src/async.tsx';
import {
	setPerformanceMarkLoadStart,
	setPerformanceMarkLoadEnd,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/performance-marks/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { PlanSidebar as PlanSidebarType } from './ui/index.tsx';

const LazyPlanSidebar = lazyForPaint<typeof PlanSidebarType>(() => {
	setPerformanceMarkLoadStart();
	return import(/* webpackChunkName: "async-sidebar-plan" */ './index').then((bundle) => {
		setPerformanceMarkLoadEnd();
		return bundle;
	});
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const PlanSidebar = memo<Record<any, any>>(() => (
	<SidebarBoundary id="Plan">
		<LazyPlanSidebar />
	</SidebarBoundary>
));

PlanSidebar.displayName = 'PlanSidebar';

export default PlanSidebar;
